

export class SmsAllocationCompanyDetailsOutput implements ISmsAllocationCompanyDetailsOutput {
    /** The auto-generated id of the company details  master */
    company_details_id!: number;

    constructor(data?: ISmsAllocationCompanyDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_details_id = _data["company_details_id"];
        }
    }

    static fromJS(data: any): SmsAllocationCompanyDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SmsAllocationCompanyDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_details_id"] = this.company_details_id;
        return data; 
    }
}

export interface ISmsAllocationCompanyDetailsOutput {
    /** The auto-generated id of the company details  master */
    company_details_id: number;
}

